import { useSelector } from 'react-redux';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
import ModulePlaceholder from 'app/components/districtModulesCommon/ModulePlaceholder';
import React from 'react';
import { useParams } from 'react-router';
import useDistrictUrls from 'app/hooks/useDistrictUrls';
import LoadingSkeleton from 'app/components/competitionModule/LoadingSkeleton';
import { ModuleWrapper } from 'app/components/competitionModule/common/styles';
export default function CompetitionModulePlaceholder() {
  const {
    districtSlug
  } = useParams();
  const {
    name
  } = useSelector(reduxSelectDistrict);
  const {
    districtCompetitionsUrl
  } = useDistrictUrls(districtSlug);
  const text = "Es gibt gerade keine aktuellen Informationen zu den Wettbewerben dieses Kreises. Hier geht es zu allen Wettbewerben aus dem Kreis ".concat(name, ".");
  return /*#__PURE__*/React.createElement(ModuleWrapper, {
    "data-sentry-element": "ModuleWrapper",
    "data-sentry-component": "CompetitionModulePlaceholder",
    "data-sentry-source-file": "CompetitionModulePlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(ModulePlaceholder, {
    text: text,
    buttonText: "Alle Wettbewerbe anzeigen",
    link: districtCompetitionsUrl,
    "data-sentry-element": "ModulePlaceholder",
    "data-sentry-source-file": "CompetitionModulePlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(LoadingSkeleton, {
    "data-sentry-element": "LoadingSkeleton",
    "data-sentry-source-file": "CompetitionModulePlaceholder.tsx"
  })));
}